module.exports = __webpack_public_path__ + "img/arrowRight.14b2c18c.svg";